module.exports = "/_next/static/images/0d4a802e43f781285f5dad157c3e3284-background-lg.png";